module.exports = __webpack_public_path__ + "img/r.64c2f5d8.svg";